import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { BookingProvider } from './context/BookingContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import VideoShowcase from './components/VideoShowcase';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import './styles/global.css';

function App() {
  return (
    <LanguageProvider>
      <BookingProvider>
        <div className="App">
          <Navbar />
          <main>
            <Hero />
            <Services />
            <Gallery />
            <Reviews />
            <VideoShowcase />
            <About />
            <Contact />
          </main>
          <Footer />
          <BookingModal />
        </div>
      </BookingProvider>
    </LanguageProvider>
  );
}

export default App;